import { z } from 'zod';
export const PTS_RESPONSIBILITIES = ['unknown', 'advise', 'design', 'manage', 'implement', 'operate', 'supply', 'resource'];
export const CHARGING_MODELS = ['unknown', 'fixed_fee', 'time_materials', 'recurring', 'pool_hours', 'resale', 'staffing'];
const text = (max) => z.string().trim().min(1).max(max);
const optionalText = (max) => z.string().trim().max(max).default('');
const date = z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine((v) => {
    const d = new Date(`${v}T00:00:00Z`);
    return Number.isFinite(d.valueOf()) && d.toISOString().slice(0, 10) === v;
}, 'Enter a real calendar date');
export const QualificationSchema = z.object({
    offices: z.number().int().nonnegative().optional(),
    people: z.number().int().nonnegative().optional(),
    architecture: z.enum(['on_prem', 'cloud', 'hybrid', 'unsure']).optional(),
    serverCount: z.number().int().nonnegative().optional(),
    supportScope: z.enum(['end_users', 'infrastructure', 'both', 'other']).optional(),
    remoteSupport: z.enum(['yes', 'no']).optional(),
    onsiteSupport: z.enum(['yes', 'no', 'unsure']).optional(),
    onsiteVisitsPerMonth: z.number().int().nonnegative().optional(),
    serviceWindow: z.enum(['business_hours', 'extended', '24x7', 'unsure']).optional(),
    poolHours: z.number().int().positive().optional(),
    areaSqFt: z.number().nonnegative().optional(),
    desks: z.number().int().nonnegative().optional(),
    positionsPerDesk: z.number().int().positive().optional(),
    floors: z.number().int().nonnegative().optional(),
    cablePoints: z.number().int().nonnegative().optional(),
    wifiSurvey: z.enum(['yes', 'no', 'unsure']).optional(),
    dataGb: z.number().nonnegative().optional(),
    targetPlatform: z.string().trim().max(500).optional(),
    projectFocus: z.string().trim().max(500).optional(),
}).strict();
export const InquiryCreateSchema = z.object({
    idempotencyKey: z.string().uuid(),
    clientId: z.string().uuid().optional(),
    companyName: optionalText(200),
    contactName: optionalText(200),
    contactGap: optionalText(500),
    contactEmail: z.union([z.literal(''), z.string().trim().email().max(254)]).default(''),
    request: text(20000),
    title: optionalText(200),
    desiredOutcome: optionalText(3000),
    ownerUserId: text(200),
    nextAction: text(500),
    nextActionDate: date,
    clientDeadline: date.nullable().default(null),
    source: optionalText(500),
    startingPoint: optionalText(100),
    qualification: QualificationSchema.default({}),
}).strict().superRefine((v, ctx) => {
    if (!v.clientId && !v.companyName)
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['companyName'], message: 'Name the company or select an existing client' });
    if (!v.contactName && !v.contactGap)
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['contactName'], message: 'Name the contact or explain what is not yet known' });
});
export const InquiryBriefEditSchema = z.object({
    expectedRevision: z.number().int().nonnegative(),
    startingPoint: text(100),
    qualification: QualificationSchema,
}).strict();
export const PackageAddSchema = z.object({
    idempotencyKey: z.string().uuid(),
    expectedRevision: z.number().int().nonnegative(),
    startingPoint: text(100),
}).strict();
export const PackageEditSchema = z.object({
    expectedRevision: z.number().int().nonnegative(),
    title: text(200),
    ptsRole: z.enum(PTS_RESPONSIBILITIES),
    chargingModel: z.enum(CHARGING_MODELS),
    scopeBoundary: optionalText(5000),
    included: z.boolean(),
}).strict();
//# sourceMappingURL=inquiry.js.map